export function getPartnerAndRegion(location: Location): { partner: string | null; region: string | null } {
  if (location.pathname.includes('amazon-prime') || location.pathname.includes('uber-pro')) {
    const pathbj = location.pathname.split('/');
    const partner = pathbj[1];
    const region = pathbj[2];
    return { partner, region };
  }
  return { partner: null, region: null };
}
